import React from "react";
import ColorField from "./ColorField";

// A colour that may be left unset. Blank means "derive it from the
// background", which is how widgets and walls behaved before text, card and
// highlight colours were settable, so the control has to offer a way back to
// that rather than only ever holding a colour.
const OptionalColor = ({ label, value, onChange }) => {
  const set = !!value;
  return (
    <div>
      <div className="flex items-center justify-between gap-2">
        <span className="zz-label">{label}</span>
        {set && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="text-[10px] font-bold uppercase tracking-wider text-slate-500 hover:text-slate-900"
          >
            auto
          </button>
        )}
      </div>
      {set ? (
        <ColorField value={value} onChange={onChange} />
      ) : (
        <button
          type="button"
          onClick={() => onChange("#000000")}
          className="mt-1 h-10 w-full border-[2px] border-dashed border-slate-400 bg-white text-[11px] font-bold text-slate-500 hover:border-black hover:text-slate-900"
        >
          auto, click to set
        </button>
      )}
    </div>
  );
};

export { OptionalColor };
export default OptionalColor;
